import { useState, useEffect } from "react";
import eventBus from 'Util/eventBus';

const GuideStock = () => {

  const [guide, setGuide] = useState("");

  useEffect(() => {
    const handleGuideEvent = (val) => {
      setGuide(val);
    };
    eventBus.on('guideStockEvent', handleGuideEvent);
    
    return () => {
      eventBus.off('guideStockEvent', handleGuideEvent);
    };
  }, [])

  function renderingContent() {
      if (guide === 'consensus') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
            <strong>공정가치</strong> <br/> 토브스탁 인공지능(AI) 알고리즘으로 산정한 <strong>"기업의 적정가치"</strong>, 절대수익모델(RIM)과 상대평가모델 등을 이용하여 분석
            <br/><br/>
            <strong>컨센서스</strong> <br/> 증권사 3곳 이상 애널리스트가 분석한 기업의 목표주가 수준
            <br/>
          </div>
        </div>
  )
    } else if (guide === 'att') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
            <strong style={{fontSize:'18px'}}>투자매력도</strong> <br/>
            1. 주가의 수준을 측정하여 <strong>과열(탐욕)</strong>되었는지 <strong>위축(공포)</strong>되었는지 가늠하는 지표 <br/><br/>
            2. <strong style={{fontSize:'16px'}}>0</strong>에 가까울수록 <strong>"공포"</strong>, <strong style={{fontSize:'16px'}}>100</strong>에 가까울수록 <strong>"탐욕"</strong> 상태 <br/><br/>
            3. 높다고 사고, 낮다고 팔라는 것이 아닙니다. 현재 주가의 <strong>"수준과 방향성"</strong>이 중요합니다. <br/><br/>
            4. <strong>탐욕</strong>에 가까워질수록 <strong>하락</strong>할 가능성이 높고, 반대로 <strong>공포</strong>에 가까워질수록 <strong>반등</strong>할 가능성이 높을 수 있습니다. <br/><br/>
            ※ 투자매력도는 기업의 일간, 주간, 월간 주가의 수익률 및 변동성 등 여러 데이터를 결합하여 측정합니다.
          </div>
        </div>
  )
    } else if (guide === 'ts') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
            <strong style={{fontSize:'18px'}}> 토브스탁 단기 매매시그널 </strong> <br/>
            1. 기업의 <strong>단기적인 매매 타이밍</strong> 분석 도구입니다.<br/><br/>
            2. <strong>"긍정"</strong>과 <strong>"부정"</strong>의 <strong>막대높이</strong>와 <strong>방향성</strong>을 활용한 매매 방식 추천합니다. <br/><br/>
            ※ MACD, 볼린저밴드, ADR 등 다양한 지표 등을 활용하여 측정합니다.
          </div>
        </div>
  )
    } else if (guide === 'hotwo') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
          <strong style={{fontSize:'18px'}}> 토브스탁 Trading Range </strong> <br/>
          1. 주가가 <strong>"저항값을 상향 돌파하면 보유"</strong> <br/>
          2. 주가가 <strong>"지지값을 하향 돌파하면 손절"</strong> <br/><br/>
          3. 주가가 <strong>"지지값에서 반등하면 매수"</strong> <br/>
          4. 주가가 <strong>"저항값에서 반락하면 매도"</strong> <br/><br/>
          ※ 피보나치, 카마릴라, 클래식 등 다양한 지지/저항 방법론을 적용하여 감정을 배재한 과학적 매매 방식입니다. <br/><br/>
          ※ <strong>일간은 1~2일, 주간은 1~2주, 월간은 3~4주</strong> 기간을 기준으로 지지/저항값을 고려하여 매매할 것을 추천합니다.
          </div>
        </div>
  )
    } else if (guide === 'season') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
          <strong style={{fontSize:'18px'}}> 토브스탁 SEASONALITY </strong> <br/>
          1. 토브스탁 인공지능(AI) 알고리즘으로 분석한 기업 주가의 <strong>"연간 계절성"</strong>입니다. <br/><br/>
          2. <strong>분석연도부터 현재</strong>까지의 연간 계절성 추세를 확인할 수 있습니다. <br/><br/>
          ※ <strong>계절성이 뚜렷한</strong> 기업을 매매할 시 매우 유용한 지표입니다. <br/><br/>
          ※ 1년에 매매가 많이 없으신<strong>(적게는 한 번, 많게는 4번)</strong> 분들이 참고하시면 좋은 지표입니다.
          </div>
        </div>
  )
    } else if (guide === 'qais') {
      return (
        <div className="guide-content">
          <div className="title">안내</div>
          <div className="text tal">
            <strong>QAIS(Quin AI Score) 종합 점수</strong> <br/>
            1. <strong>성장, 가치, 성과, 안정성, 모멘텀</strong> 등 기업의 가치를 평가하는 5개 중요 변수를 학습 및 분석하여 상대평가 점수화 <br/><br/>
            2. 위 5개의 중요 변수는 각 1~3개의 세부 요인으로 세분 <br/><br/>
            3. <strong>0 ~ 100점</strong> 값을 가지고 있으며 100으로 갈수록 좋음
          </div>
        </div>
      )
    }
  }

  return (
    <div className={(guide && guide !== "") ? "stock_popup is-active" : "stock_popup"}>
      <div className="popup">
        {renderingContent()}
        <div className="button">
          <button 
            className="close"
            onClick={(e) => {
              e.preventDefault();
              setGuide("");
            }}
          >확인</button>
        </div>
      </div>
      <div className="dimmed"></div>
    </div>
  )
}

export default GuideStock;
